module.exports = __webpack_public_path__ + "static/img/line.2edb68a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/UST/line.png
// module id = Se/C
// module chunks = 3